
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
import { watchEffect, computed } from "vue";
import { ChallengeSettings } from "../../../model/ChallengeSettings.model";
@Options({
  props: ["data"]
})
export default class Timer extends Base {
  public totalTime = { value: 10 };
  secondPerQuestion = "auto";
  public data!: any;
  disabledAuto = false;
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  public timer = [
    { value: 1 },
    { value: 3 },
    { value: 5 },
    { value: 10 },
    { value: "other" }
  ];
  created() {
    watchEffect(() => {
      const data = {
        totalTime: this.totalTime.value,
        secondQuestion: this.secondPerQuestion
      };
      this.$emit("update:data", data);
    });
  }

  selectTimer(e: any) {
    if (e.value.value === "other") {
      this.secondPerQuestion = "manually";
    }
    this.disabledAuto = e.value.value === "other";
  }
}
